/**
 * Shared brand assets used across marketing/onboarding surfaces.
 * Centralizes the CDN URLs so they can be updated in one place.
 */
export const COMPLIMIND_LOGO_URL =
  'https://innexpublic.blob.core.windows.net/platform-assets/complimind-logo/LOGO%20PNG%20TRANSPARENT-02.png';

export interface TrustLogo {
  alt: string;
  src: string;
  height: number;
}

export const TRUST_LOGOS: TrustLogo[] = [
  {
    alt: 'Somerset NHS Foundation Trust',
    src: 'https://innexpublic.blob.core.windows.net/platform-assets/organisations/somerset.png',
    height: 42
  },
  {
    alt: 'Cambridge University Hospitals',
    src: 'https://innexpublic.blob.core.windows.net/platform-assets/organisations/cuh.png',
    height: 50
  },
  {
    alt: 'Liverpool University Hospitals',
    src: 'https://innexpublic.blob.core.windows.net/platform-assets/organisations/liverpool.png',
    height: 50
  },
  {
    alt: 'University Hospitals Birmingham',
    src: 'https://innexpublic.blob.core.windows.net/platform-assets/organisations/birmingham.png',
    height: 54
  }
];
